module.exports = __webpack_public_path__ + "img/buergerliche_kueche.92407fe2.jpg";